import { isInvoicePaid } from '../utils';
import { Timeline } from './Timeline';
import React from 'react';
import { LoyaltyBenefitConsultation } from './LoyaltyBenefitConsultation';
import _ from 'lodash';
import { useTimelineData } from '../hooks/useTimelineData';

export const PlanBenefits = () => {
  const timelineData = useTimelineData();
  if (timelineData.type === 'component') return timelineData.statusComponent;

  const data = timelineData.data;
  const specialBenefitsEligibility =
    data.historicInvoices.every(isInvoicePaid) &&
    _(data.invoicesAndBenefits)
      .takeWhile((x) => typeof x.invoice === 'object' && x.invoice && isInvoicePaid(x.invoice))
      .some((x) => x.specialBenefits.length > 0);

  return (
    <div className="billing-section w-100" data-test="plan-benefits">
      <div className="billing-section__header">Plan benefits</div>
      <div className="billing__timeline-container">
        <Timeline
          segmentsPerYear={data.billingPlan.months.length}
          invoicesAndBenefits={data.invoicesAndBenefits}
          historicInvoices={data.historicInvoices}
        />
        {specialBenefitsEligibility && <LoyaltyBenefitConsultation />}
      </div>
    </div>
  );
};
